import React from 'react';
import classnames from 'classnames';

import { routes, url } from 'oo-routes';
import Link from 'sp-components/components/Link';

import { getStartedLink } from '../../util';

export default class GetStarted extends React.Component {
  render() {
    const pageType = this.props.pageType;
    const getStarted = getStartedLink(this.props.user);
    const contact = url('website', routes.website.home.contact);

    return (
      <div className={classnames('background', pageType)}>
        <div className="ui container p-tb-4 center-aligned">
          <h1>Start printing without the hassle</h1>
          <Link to={getStarted}>
            <button className="get-started inverted">Get started</button>
          </Link>
          <Link to={contact}>
            <h4 className="thick-text p-t-1">
              Contact Sales
              <i className="icon right angle" />
            </h4>
          </Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/GetStarted/index.jsx